import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=6f66790c"
import script from "./radio.vue?vue&type=script&lang=ts"
export * from "./radio.vue?vue&type=script&lang=ts"
import style0 from "./radio.vue?vue&type=style&index=0&id=6f66790c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports